import { Modal, Table } from "antd";
import {
  ExportOutlined,
  HistoryOutlined,
  UpOutlined,
  DownOutlined,
} from "@ant-design/icons";
import { CALL_API } from "common/API";
import { STATUS_CODE } from "common/Constants";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { getUserInfo, getUserList } from "redux/selectors";

const BadgeContainer = styled.div`
  position: fixed;
  left: ${({ collapsed }) => (collapsed ? "94px" : "294px")};
  bottom: 24px;
  z-index: 1000;

  transition: left 0.2s ease;
`;

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  background: #f5f5f5;
  color: #595959;

  border-radius: 20px;
  padding: 8px 14px;

  font-size: 13px;
  cursor: pointer;

  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);

  transition: all 0.2s ease;

  &:hover {
    background: #eee;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.16);
  }
`;

const capitalize = (text) =>
  text ? text.charAt(0).toUpperCase() + text.slice(1) : text;

const formatDateTime = (value) =>
  value ? dayjs(value).format("Do MMM YYYY; hh:mm A") : "-";

const KpiHistoryBadge = ({ contractid }) => {
  const userInfo = useSelector(getUserInfo);
  const userList = useSelector(getUserList);

  const [historyList, setHistoryList] = useState([]);
  const [open, setOpen] = useState(false);

  const capitalize = (text) =>
  text ? text.charAt(0).toUpperCase() + text.slice(1) : text;

const formatAction = (text) =>
  capitalize(text).replace(/\bkpi\b/gi, "KPI");

  const fetchHistory = async () => {
    try {
      const { historyList: list, code } = await CALL_API(
        `performance-kpi-management/history/${contractid}`,
        "get"
      );

      if (code === STATUS_CODE.SUCCESS) {
        setHistoryList(Array.isArray(list) ? list : []);
      }
    } catch (error) {
      console.error("Error fetching KPI history:", error);
    }
  };

  useEffect(() => {
    if (contractid) {
      fetchHistory();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractid]);

  const nameFor = (actionby) => {
    if (actionby === userInfo?.userid) {
      return "You";
    }

    return (
      userList?.find((user) => user.userid === actionby)?.fullname ||
      actionby ||
      "-"
    );
  };

  const latest = historyList[0];

  const columns = [
  {
    title: "Action by",
    key: "actionby",
    render: (_, record) => (
      <>
        {formatAction(record.action)} by <b>{nameFor(record.actionby)}</b>
      </>
    ),
  },
  {
    title: "Date & Time",
    dataIndex: "actionat",
    key: "actionat",
    render: formatDateTime,
  },
];

  const collapsed = window.localStorage.getItem("collapsed") === "true";

  return (
    <>
      {/* 
        94px keeps the button outside the 70px side menu.
        Change this value according to your actual sidebar width.
      */}
      <BadgeContainer collapsed={collapsed}>
        <Badge onClick={() => setOpen(true)}>
         {latest ? (
  <>
    <span>
      {formatAction(latest.action)} on:{" "}
      <b>{formatDateTime(latest.actionat)}</b>
    </span>
    <ExportOutlined />
  </>
) : (
  <>
    <HistoryOutlined />
    <span>History</span>
  </>
)}
        </Badge>
      </BadgeContainer>

      <Modal
        title="KPI Planning History"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        width={640}
        centered
      >
        <Table
  columns={columns}
  dataSource={historyList}
  pagination={false}
  rowKey={(record) => record.id}
  expandable={{
    expandIconColumnIndex: columns.length,
    rowExpandable: (record) => Boolean(record.remarks),
    expandedRowRender: (record) => (
      <div>
        <b>
          {record.action === "revision requested"
            ? "Reason for revision: "
            : "Reason: "}
        </b>
        {record.remarks}
      </div>
    ),
    expandIcon: ({ expanded, onExpand, record }) =>
      record.remarks ? (
        expanded ? (
          <UpOutlined
            style={{ color: "#1677ff", cursor: "pointer" }}
            onClick={(e) => onExpand(record, e)}
          />
        ) : (
          <DownOutlined
            style={{ color: "#8c8c8c", cursor: "pointer" }}
            onClick={(e) => onExpand(record, e)}
          />
        )
      ) : null,
  }}
/>
      </Modal>
    </>
  );
};

export default KpiHistoryBadge;